import { Search } from "@carbon/react";
import PropTypes from 'prop-types';
import React from 'react';

function ProductsIndexSearch({ value, onChange, onClear }) {
  function handleOnChange(event) {
    onChange(event.target.value);
  }
  function handleOnClear(event) {
    onClear(null);
  }

  return (
    <div className="component-index-search">
      <Search
        id="component-index-search"
        size='lg'
        labelText="Поиск товаров по артикулю"
        placeholder="Поиск товаров"
        value={value}
        onChange={handleOnChange}
        onClear={handleOnClear}
      />
    </div>
  );
}

ProductsIndexSearch.propTypes = {
  /**
   * Receive an update for the latest value and use it to update the passed in
   * `value`
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Control the value of the search using the `value` prop
   */
  value: PropTypes.string.isRequired,
};

export default ProductsIndexSearch;
